import { Button } from '@cluey/cluey-components';
import { useState } from 'react';

import { BillingInformationType } from '../../../../../types/hubPropTypes';
import { PaymentMethodForm } from './PaymentMethod/PaymentMethodForm';

export type SavedPaymentDetailsProps = {
  billingInformation: BillingInformationType;
};

const SavedPaymentDetails = ({ billingInformation = {} }: SavedPaymentDetailsProps) => {
  const [paymentMethodViewEditMode, setPaymentMethodViewEditMode] = useState<'view' | 'edit'>('view');
  const { endingIn = 'XXXX' } = billingInformation ?? {};

  if (paymentMethodViewEditMode === 'view') {
    return (
      <div>
        <h3 className="mb-3 font-display font-bold">Payment details</h3>
        <div>
          <p className="mb-0 pb-4 leading-none">Credit card ending **** {endingIn.replace(/\*/g, '')}</p>
        </div>
        <Button
          appearance="reverse"
          size="xs"
          onClick={() => {
            setPaymentMethodViewEditMode('edit');
          }}
        >
          EDIT PAYMENT DETAILS
        </Button>
      </div>
    );
  } else if (paymentMethodViewEditMode === 'edit') {
    return (
      <PaymentMethodForm
        zuoraAccountId={billingInformation?.zuoraId}
        onCancel={() => {
          setPaymentMethodViewEditMode('view');
        }}
        onSuccess={() => {
          setPaymentMethodViewEditMode('view');
        }}
      />
    );
  }
  return null;
};

export default SavedPaymentDetails;
